import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import H3 from '../../typography/headers/H3'
import IconDelete from '../../../static/images/icon_delete.svg'
import IconDeleteRed from '../../../static/images/icon_delete_redhover.svg'
import LinkIcon from '../../../static/images/questskills/icon_link.svg'
import { deleteQuestSkill } from '../../../actions/questskills'

const SkillItemContainer = styled.div`
  padding: 12px 30px 12px 0px;
  display: flex;
  align-items: center;
  border-bottom: 1px solid #bbbbbb;
`

const StyledIconDelete = styled.div`
  background: url(${IconDelete}) no-repeat;
  width: 12px;
  height: 15px;
  cursor: pointer;
  margin-left: auto;

  &:hover {
    background: url(${IconDeleteRed}) no-repeat;
  }
`

const StyledIconLink = styled.div`
  background: url(${LinkIcon}) no-repeat;
  height: 17px;
  width: 14px;
  margin-right: 12px;
`

class SkillItem extends React.Component {
  constructor() {
    super()

    this.onDeleteClickBound = this.onDeleteClick.bind(this)
  }

  render() {
    const { skill, allowEdit } = this.props

    return (
      <SkillItemContainer id={`skill-${skill.framework_skill_id}`}>
        <StyledIconLink />
        <H3 textTruncate>{skill.name}</H3>
        {allowEdit && <StyledIconDelete onClick={this.onDeleteClickBound} />}
      </SkillItemContainer>
    )
  }

  onDeleteClick() {
    const confirmation = window.confirm(
      'Are you sure you want to remove this skill link?'
    )
    if (confirmation) {
      this.props.dispatch(deleteQuestSkill(this.props.skill.framework_skill_id))
    }
  }
}

SkillItem.propTypes = {
  skill: PropTypes.object.isRequired,
  dispatch: PropTypes.func.isRequired,
  allowEdit: PropTypes.bool.isRequired
}

export default SkillItem



// WEBPACK FOOTER //
// ./src/components/quest/skills/SkillItem.js